import React from 'react'
import { Table, TableContainer } from '@mui/material'
import RoomsHead from './RoomsHead'
import RoomsBody from './RoomsBody'
import './RoomsTable.scss'

const RoomsTable = () => {
  return (
    <TableContainer>
      <Table className="rooms-table">
        <RoomsHead />
        <RoomsBody />
      </Table>
    </TableContainer>
  )
}

export default RoomsTable
